import React from "react"

export function useShiftChangesPanel({ recordId, open }: { recordId?: string; open: boolean }) {
  const [changesOpen, setChangesOpen] = React.useState(false)

  React.useEffect(() => {
    setChangesOpen(false)
  }, [recordId])

  React.useEffect(() => {
    if (!open) {
      setChangesOpen(false)
    }
  }, [open])

  return {
    changesOpen,
    setChangesOpen,
  }
}
